import BaseAPI from "./BaseAPI";
import { getAPIUrlV2 } from "../apiConfig";

export default class BatchAPI extends BaseAPI {
    constructor(emitter) {
        super(emitter, "batches", "batch-storage");
    }
    Journey(key) {
        return this._request("get", this._url(`/${encodeURIComponent(key)}`));
    }
    async AddFoodRecord(key, data, idempotencyKey) {
        const result = await this._request(
            "post",
            this._url(`/${encodeURIComponent(key)}/food-records`),
            data,
            { headers: { "Idempotency-Key": idempotencyKey } }
        );
        this.emitter.emit("food-record-add", result.log.id);
        this.emitter.emit("food-record-item-add", result.item.id);
        return result;
    }
    async AddStorage(key, data, idempotencyKey) {
        const result = await this._request(
            "post",
            this._url(`/${encodeURIComponent(key)}/storage`),
            data,
            { headers: { "Idempotency-Key": idempotencyKey } }
        );
        this._emit("add", result.id);
        return result;
    }
    async UpdateStorage(id, data) {
        const result = await this._request("put", `${getAPIUrlV2("batch-storage")}/${id}`, data);
        this._emit("update", id);
        return result;
    }
}
